import { Injectable } from '@angular/core';
import { Registration } from '@enus/model/registration';

@Injectable({
    providedIn: 'root'
})

export class ProposalContactDataService {
    constructor() {}

    public saveRegistrationData(registration: Registration): void {
        localStorage.setItem(registration.id, JSON.stringify({ registration: registration}));
    }

    public getRegistrationData(id: string): Registration {
        return JSON.parse(localStorage.getItem(id)).registration;
    }
}
